module.exports = __webpack_public_path__ + "img/tisco.616e36c9.svg";